const theme = {
  colors: {
    text: '#BB8B4B',
    background: '#001028',
   },
  fonts: {
    body: 'Kaisei Opti, sans-serif',
    heading: 'Kaisei Opti, sans-serif',
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
}


  
export default theme